inputs-complex-delivery-attachments
  div(class="form-group row {error: opts.errors}")
    label.col-md-4.col-form-label
      | {opts.label}
    .col-md-8
      inputs-without-label-radio-multiple(tag-scope="{this.tagScope}.fixed_status")
      div(each="{item, namespace in opts.items}" class="{(item.value == '1') ? 'checked' : ''}")
        .d-flex
          div
            .checkbox-fade.fade-in-primary
              input(type="hidden" value="0" name="{ item.name }")
              label
                input(if="{ item.value == '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChangeCheckbox }" data-id="{namespace}" checked="checked")
                input(if="{ item.value != '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChangeCheckbox }" data-id="{namespace}")
                span.cr
                  i.cr-icon.icofont.icofont-ui-check.txt-primary
                span { item.label }
          div.how_to_send(if="{item.how_to_send}")
            span.radio-wrap(each="{item, index in item.how_to_send.items}")
              input(if="{ item.value == parent.item.how_to_send.value }" onChange="{onChangeHowToSend(namespace)}" checked="checked" id="{this.tagScope}_{index}" type="radio" value="{ item.value }" name="{ parent.item.how_to_send.name }")
              input(if="{ item.value != parent.item.how_to_send.value }" onChange="{onChangeHowToSend(namespace)}" id="{this.tagScope}_{index}" type="radio" value="{ item.value }" name="{ parent.item.how_to_send.name }")
              label(for="{this.tagScope}_{index}") { item.label }
          div.delivery_pattern(if="{item.delivery_pattern}")
            select.form-control.thin(name="{ item.delivery_pattern.name }" onChange="{onChangeDeliveryPattern(namespace)}")
              option(each="{ item, index in item.delivery_pattern.items }" selected="{ selected: item.value === parent.item.delivery_pattern.value }" value="{ item.value }") { item.label }
          div.bills_pattern(if="{item.bills_pattern}")
            input.form-control.thin(type="text" onChange="{onChangeBillsPattern(namespace)}" name="{ item.bills_pattern.name }" value="{ item.bills_pattern.value }" placeholder="{ item.bills_pattern.placeholder }")
        div.mb-2.memo_for_inspection(if="{item.memo_for_inspection}")
          textarea.form-control(name="{item.memo_for_inspection.name}" onChange="{onChangeMemoForInspection(namespace)}" placeholder="{item.memo_for_inspection.placeholder}" rows="3") { item.memo_for_inspection.value }
        div.mb-2.send_to(if="{item.send_to}")
          textarea.form-control(name="{item.send_to.name}" onChange="{onChangeSendTo(namespace)}" placeholder="{item.send_to.placeholder}" rows="1") { item.send_to.value }
  script(type="typescript").
    this.mixin('inputs.complex.delivery-attachments')
  style(scoped).
    select.form-control, select.form-control:focus, select.form-control:hover {
      border: 1px solid rgb(204, 204, 204);
    }
    input.form-control.thin, input.form-control.thin:focus, input.form-control.thin:hover,
    select.form-control.thin, select.form-control.thin:focus, select.form-control.thin:hover {
      padding: 2px 12px;
      height: calc(1.4em + 0.25rem + 3px);
    }
    .how_to_send, .delivery_pattern, .bills_pattern, .memo_for_inspection, .send_to {
      display: none;
    }
    .checked .how_to_send, .checked .delivery_pattern, .checked .bills_pattern, .checked .memo_for_inspection, .checked .send_to {
      display: block;
    }
    .bills_pattern input{
      width: 25rem;
    }

        
